import { StandardLink, StandardLinkProps } from '@brandfolder/react';
import React from 'react';

export const BFStandardLink: React.FC<StandardLinkProps> = (props) => {
  return <StandardLink {...props}>{props.children}</StandardLink>;
};
